// Loading.tsx
import "./index.css";
import logo from '../../assets/originelogo.png'
export default function Loading() {
  return (
    <div className="loading">
      <div className="logo-wrap">
        <img className="logo" src={logo} alt="Logo" />
        <span className="logo-shine" aria-hidden="true" />
      </div>
    </div>
  );
}
